<template>
  <basic-container>
    <el-dialog
      title="查看评价"
      :visible.sync="openFlag"
      :modal-append-to-body="false"
      width="64%"
      @closed="handleClose"
    >
      <avue-crud
        :option="option"
        :table-loading="loading"
        :data="data"
        :page.sync="page"
        :permission="permissionList"
        :before-open="beforeOpen"
        v-model="form"
        ref="crud"
        @row-update="rowUpdate"
        @row-save="rowSave"
        @row-del="rowDel"
        @search-change="searchChange"
        @search-reset="searchReset"
        @selection-change="selectionChange"
        @current-change="currentChange"
        @size-change="sizeChange"
        @on-load="onLoad"
        @refresh-change="onLoad"
      >
        <template slot-scope="scope" slot="menu">
          <el-button type="text" size="small" icon="el-icon-view" @click="addReview(scope.row)"
            >回复</el-button
          >
        </template>
      </avue-crud>
    </el-dialog>
  </basic-container>
</template>

<script>
import { add, getDetail, getList, remove, update, addReview } from '@/api/v4ward/review/review';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      openFlag: false,
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 'auto',
        tip: false,
        border: true,
        index: true,
        indexLabel: '序号',
        column: [
          {
            label: '评论内容',
            prop: 'content',
            rules: [
              {
                required: true,
                message: '请输入评论内容',
                trigger: 'change',
              },
            ],
            width: 600,
          },
          {
            label: '评论人',
            prop: 'createName',
          },
          {
            label: '时间',
            prop: 'createTime',
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.review_add, false),
        viewBtn: this.vaildData(this.permission.review_view, false),
        delBtn: this.vaildData(this.permission.review_delete, false),
        editBtn: this.vaildData(this.permission.review_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  methods: {
    rowSave(row, loading, done) {
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
    handleClose() {
      this.data = [];
    },
    openReviewDialog(id) {
      this.query.repairInfoId = id;
      this.query.reviewType = 0;
      this.onLoad();
      this.openFlag = true;
    },
    addReview(row, done) {
      this.$prompt('回复：', {
        confirmButtonText: '保存',
        cancelButtonText: '取消',
        inputType: 'textarea',
      })
        .then(({ value }) => {
          if (!value) {
            this.$message.error('请输入回复内容!');
            return;
          }
          addReview({ reviewId: row.id, repairInfoId: row.repairInfoId, content: value }).then(
            () => {
              this.onLoad();
              this.$message.success('操作成功!');
            },
            (error) => {
              done();
              console.log(error);
            }
          );
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped></style>
